// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__X4MeQ","inversion":"Section_inversion__yfY8_"};